import React from 'react';
import { Card, CardContent, Typography, Box, Stack } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

export default function StatCard({ label, value, color = 'text.primary', trend, trendLabel, icon: Icon, subtitle }) {
  const isPositiveTrend = trend === 'up';

  return (
    <Card
      sx={{
        position: 'relative',
        overflow: 'hidden',
        height: '100%',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          bgcolor: color,
        },
      }}
    >
      <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
        <Typography
          variant="overline"
          sx={{
            color: 'text.secondary',
            fontSize: '0.68rem',
            fontWeight: 600,
            letterSpacing: '0.8px',
            display: 'block',
            mb: 0.5,
          }}
        >
          {label}
        </Typography>
        <Stack direction="row" alignItems="flex-end" justifyContent="space-between">
          <Box>
            <Typography variant="h4" sx={{ color, fontWeight: 700, lineHeight: 1.2 }}>
              {value}
            </Typography>
            {trendLabel && (
              <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mt: 0.5 }}>
                {trend === 'up' ? (
                  <ArrowUpwardIcon sx={{ fontSize: 14, color: isPositiveTrend ? 'error.main' : 'success.main' }} />
                ) : (
                  <ArrowDownwardIcon sx={{ fontSize: 14, color: isPositiveTrend ? 'error.main' : 'success.main' }} />
                )}
                <Typography variant="caption" color={isPositiveTrend ? 'error.main' : 'success.main'}>
                  {trendLabel}
                </Typography>
              </Stack>
            )}
            {subtitle && (
              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {Icon && (
            <Box sx={{ p: 1, borderRadius: 2, bgcolor: 'background.subtle' }}>
              <Icon sx={{ color: 'text.secondary', fontSize: 20 }} />
            </Box>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
